module.exports = __webpack_public_path__ + "img/egypt-Unselected.d4f0c2a6.webp";